import { loadStripe } from "@stripe/stripe-js";

let stripePromise = null;

export function getStripePublishableKey() {
  return String(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "").trim();
}

export function isStripeCheckoutConfigured() {
  return Boolean(getStripePublishableKey());
}

export function getAudiologistStripePromise() {
  const key = getStripePublishableKey();
  if (!key) return null;
  if (!stripePromise) {
    stripePromise = loadStripe(key);
  }
  return stripePromise;
}
